<template>
  <div id="app">
    <!-- 使用手機 -->
    <div v-if="device !== 'desktop'">
      <!-- 標題 -->
      <h1 style="color: black; font-size: 20px;">{{ $t('Login.title') }}</h1>
      <p style="color: black; margin-top: -10px;"><a href="https://www.eilis-ai.com/" style="color: #777">{{ $t('Login.powerby') }}</a></p>
      <!-- 第一步驟:輸入電話 -->
      <phoneVer v-if="active === 0"
        :number="number"
        :phoneNum="user.phone"
        :token="user.token"
        :service="platform"
        @sendSMS="receivedSMS"
        @getCountryCode="getCountryCode"/>
      <!-- 第二步驟:驗證碼 -->
      <codeVer v-if="active === 1"
        :number="number"
        :code="code"
        @activeIcon="activeIcon"
        @sendSMS="receivedSMS"
        @checkFastLogin="checkFastLogin"/>
      <!-- 第三步驟:基本資訊 -->
      <basic v-if="active === 2"
        :service="platform"
        :auth="pageData.auth"
        :noVer="config.noVer"
        :birthData="birth"
        :userData="user"
        :requireEmail="config.requireEmail"
        :isEmail="config.isEmail"
        :privacyUrl="config.privacyUrl"
        :autoRecom="config.autoRecom"
        :isLoginRecom="config.isLoginRecom"
        @sendMember="sendMember"/>
    </div>
    <!-- 桌機版 -->
    <div v-else>
      <div style="margin-top: 30px;">
        <el-row :gutter="100">
          <el-col :span="12" style="text-align: right;">
            <div style="padding-right: 40px; margin-bottom: 10px;">
              <div class="hintBox">iOS</div>
            </div>
            <canvas ref="QRCode"></canvas>
          </el-col>
          <el-col :span="12" style="text-align: left;">
            <div style="padding-left: 40px; margin-bottom: 10px;">
              <div class="hintBox">Android</div>
            </div>
            <canvas ref="QRCode2"></canvas>
          </el-col>
        </el-row>
        <br><br>
        <div style="font-size: 17px; color: black;">{{ $t('Login.no_service') }}</div>
        <div style="font-size: 17px; color: black;">{{ $t('Login.scan_code') }}</div>
      </div>
    </div>
    <!-- 小幫手 -->
    <div style="position: absolute; bottom: 20px; left: 15px;" v-if="active === 1">
      <div style="position: relative;" v-show="showIcon" @click="openNotCodeDia = true">
        <img src="./operator.png" loading="lazy" width="80"/>
        <div class="trian"></div>
        <div class="box">無法成功註冊嗎？請點我查看說明</div>
      </div>
    </div>
    <!-- 收不到驗證碼 -->
    <mu-dialog :open.sync="openNotCodeDia" width="80%">
      <div style="margin-bottom: 10px;">
        <el-row :gutter="10">
          <el-col :span="6">
            <img src="./operator.png" width="100%">
          </el-col>
          <el-col :span="18">
            <div style="line-height: 60px; font-size: 18px;">親愛的顧客您好</div>
          </el-col>
        </el-row>
      </div>
      <div>當您嘗試多次仍收不到驗證碼</div>
      <div>有以下可能：</div><br>
      <div><b>1.⾏動電話號碼輸入錯誤。</b></div>
      <div><b>2.國碼輸入錯誤。</b></div>
      <div><b>3.⼿機安裝阻擋簡訊軟體。</b></div><br>
      <div>如無法順利註冊，請洽詢客服。</div><br>
      <mu-button color="#982734" style="width: 100%;" @click="openSheet">我知道了，前往聯繫客服</mu-button>
    </mu-dialog>
    <!-- 缺少參數：page -->
    <mu-dialog :open="errorDia" width="70%">
      {{ $t(errorMsg) }}
    </mu-dialog>
    <!-- 載入資料畫面 -->
    <mu-dialog :open="pageLoading" width="70%">
      <div style="text-align: center;">
        <mu-circular-progress class="demo-circular-progress" :size="36"></mu-circular-progress>
        <div>{{ $t(loadingMsg) }}</div>
      </div>
    </mu-dialog>
    <!-- 取得 LINE TOKEN 錯誤 -->
    <mu-dialog :open="errorLineToken" width="70%">
      <div style="text-align: center;">{{ errorLog }}</div>
      <br>
      <div>發生錯誤！請檢查您的 LINE 是否已更新到 10.15.0 以後的版本，並嘗試重新登入。</div>
      <div>若仍然出現此錯誤，請先螢幕錄影並通知客服人員協助處理，造成您的不便深感抱歉。</div>
      <div style="margin-top: 15px; text-align: center;">
        <el-button type="danger" @click="lineAddFriend">加入 LINE 好友</el-button>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import QRCode from 'qrcode'
import { mapGetters, mapActions, createNamespacedHelpers } from 'vuex';

import QrcodeVue from 'qrcode.vue';
import phoneVer  from './register/phoneVer';
import codeVer   from './register/codeVer';
import basic     from './register/basic';

const register = createNamespacedHelpers('register');

export default {
  name: 'registerBeta',
  data() {
    return {
      platform: this.$route.params.service,
      device: 'desktop',
      pageLoading: false,
      loadingMsg: 'Login.loading',
      basicId: '',
      qrcode: '',
      qrcodeAndroid: '',
      openNotCodeDia: false,
      showIcon: false,
      errorDia: false,
      errorMsg: '',
      errorLineToken: false,
      errorLog: '',
      content: '',
      active: '',
      number: 0,
      code: '',
      fastClearance: {
        isBind: false,
        isUser: false,
        bindingData: {}
      },
      config: {
        autoRecom: '',
        notReceivedLink: '',
        privacyUrl: '',
        isLoginRecom: false,
        loginRecom: null,
        isLIFF: false,
        noVer: false,
        isEmail: false,
        double: false,
        requireEmail: false
      },
      user: {
        token: '',
        name: '',
        phone: '',
        birth: '',
        email: '',
        remark: '',
        recom: '',
        countryCode: '886'
      },
      birth: {
        year: '1990',
        month: '01',
        date: '01'
      }
    };
  },
  components: {
    phoneVer, codeVer, basic, QrcodeVue
  },
  computed: {
    ...mapGetters({
      pageData : 'pageData',
      userData : 'userData',
      account  : 'account'
    }),
    ...register.mapGetters({
      aesCode   : 'aesCode',
      lineToken : 'lineToken',
      lineName  : 'lineName',
    })
  },
  mounted() {
    // LIFF
    const liffId = this.checkParam('liffId');
    const content = this.checkParam('content');
    // 確定是手機
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = 'mobile';
      const page = this.checkParam('page');
      const tab = this.checkParam('tab');
      const token = this.checkParam('UToken');
      // 撈取會員資料
      this.pageLoading = true;
      this.loadingMsg = 'Login.check_init';

      // 指定頁面
      if (tab) {
        localStorage.setItem('tab', tab);
      }
      else {
        localStorage.setItem('tab', '');
      }

      if (liffId) {
        // 第一次 init 如果後面帶參數會跳轉
        liff.init({ liffId }).then(() => {
          // 取得會員資料
          this.loadingMsg = 'Login.checking_user';
          liff.getProfile().then((_profile) => {
            this.user.token = _profile.userId;
            this.user.name = _profile.displayName;
            this.content = content;
            localStorage.setItem('pictureUrl', _profile.pictureUrl);
            this.filterPage(page);
          })
          // 取得會員資料失敗
          .catch((e) => {
            this.pageLoading = false;
            this.errorLog = 'GET USER ERROR';
          })
        })
        // 初始化失敗
        .catch((e) => {
          this.pageLoading = false;
          this.errorLog = 'LIFF INIT ERROR';
        })
      }
      else {
        // 檢查資料
        this.user.token = token;
        this.content = content;
        this.filterPage(page);
      }
    }
    else {
      if (liffId) {
        if (!content) {
          this.qrcode = `line://liff.line.me/${liffId}`;
          this.qrcodeAndroid = `line://app/${liffId}`;
          const element = this.$refs.QRCode;
          const element2 = this.$refs.QRCode2;
          QRCode.toCanvas(element, this.qrcode, this.options, error => {})
          QRCode.toCanvas(element2, this.qrcodeAndroid, this.options, error => {})
        }
        else {
          this.qrcode = `line://liff.line.me/${liffId}?content=${content}`;
          this.qrcodeAndroid = `line://app/${liffId}?content=${content}`;
          const element = this.$refs.QRCode;
          const element2 = this.$refs.QRCode2;
          QRCode.toCanvas(element, this.qrcode, this.options, error => {})
          QRCode.toCanvas(element2, this.qrcodeAndroid, this.options, error => {})
        }
      }
      else {
        this.qrcode = location.href;
        this.qrcodeAndroid = location.href;
        const element = this.$refs.QRCode;
        const element2 = this.$refs.QRCode2;
        QRCode.toCanvas(element, this.qrcode, this.options, error => {})
        QRCode.toCanvas(element2, this.qrcodeAndroid, this.options, error => {})
      }
      try {
        history.replaceState('eilis', null, 'https://emcpro.eilis-ai.com/');
      }
      catch(e) {
        console.log(e);
      }
    }
  },
  methods: {
    ...mapActions({
      getPageData    : 'getPageData',   // 檢查是否是 LINE 會員
      checkUserFB    : 'checkUserFB',   // 檢查是否是 FB 會員
      checkUserLINE  : 'checkUserLINE', // 檢查是否是 LINE 會員
      checkAccount   : 'checkAccount',  // 檢查專頁資訊
      addUserTag     : 'addUserTag',
      serUserToMemberMenu : 'serUserToMemberMenu'
    }),
    ...register.mapActions({
      checkPhone          : 'checkPhone',
      getBasicId          : 'getBasicId',
      getEncryptData      : 'getEncryptData',
      getLiffProfile      : 'getLiffProfile',
      saveToNotReceiveList: 'saveToNotReceiveList',
      getNotReceivedUser  : 'getNotReceivedUser',
      checkBindAcc        : 'checkBindAcc',     // 檢查雙平台
      sendSMS             : 'sendSMS',          // 發簡訊
      checkBindUser       : 'checkBindUser',    // 檢查是否綁定
      sendMemberAPI       : 'sendMemberAPI',    // 串接客戶會員
      sendLoginRecom      : 'sendLoginRecom',   // 註冊推薦
      createUser          : 'createUser',       // 新增會員
      getAESData          : 'getAESData',       // 取得加密資料
      getAESCode          : 'getAESCode',       // 取得加密參數
      exchangeGiftCode    : 'exchangeGiftCode', // 兌換禮物碼
      fastLogin           : 'fastLogin'         // 快速通關
    }),
    showNotify(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    a() {
      this.number -= 1;
    },
    b() {
      this.number = 60;
      var si = setInterval(this.a, 1000);
      setTimeout(() => {
        this.number = 0;
        clearInterval(si);
      }, 60000);
    },
    lineAddFriend() {
      location.href = `https://line.me/R/ti/p/${this.basicId}`;
    },
    openSheet() {
      this.openNotCodeDia = false;
      window.open(this.config.notReceivedLink);
    },
    activeIcon() {
      if (this.config.notReceivedLink) {
        const postData = {
          auth: this.pageData.auth,
          token: this.user.token,
          phone: this.user.phone,
          service: this.platform
        };
        this.saveToNotReceiveList(postData);
        this.showIcon = true;
      }
    },
    // 取得國碼
    getCountryCode(code) {
      this.user.countryCode = code;
    },
    // 簡訊驗證
    receivedSMS(phone) {
      this.user.phone = phone ? phone : this.user.phone;
      // 免驗證登入
      if (this.config.noVer) {
        this.checkFastLogin();
      }
      else {
        this.b();
        const random = new Array('0','1','2','3','4','5','6','7','8','9');
        let code = '';
        for (let e = 0; e < 6; e += 1) {
          const index = Math.floor(Math.random() * 10);
          code += random[index];
        }
        // console.log(code);
        this.code = code;
        this.sendSMS({ phone: this.user.phone, code: this.code, service: this.platform, auth: this.pageData.auth, countryCode: this.user.countryCode });
        this.active = 1;
      }
    },
    // 進入首頁
    gotoMainPage() {
      const tab = localStorage.getItem('tab');
      localStorage.setItem(this.pageData.auth, this.user.token);
      this.$router.push(`/memberpage/${this.platform}?tab=${tab}`);
    },
    fixedString(str) {
      return str.replace(/%3D/g, '=').replace(/%26/g, '&').replace(/%3F/g, '?').replace(/%2B/g, '+').replace(/%2F/g, '/').replace(/%252F/g, '/').replace(/%253D/g, '=').replace(/%20/g, '+');
    },
    checkParam(str) {
      const querystr = this.fixedString(window.location.search);
      // 判斷字串
      if (querystr.split(`&${str}=`)[1]) {
        return querystr.split(`&${str}=`)[1].split('&')[0];
      }
      else if (querystr.split(`?${str}=`)[1]) {
        return querystr.split(`?${str}=`)[1].split('&')[0];
      }
      else {
        return '';
      }
    },
    filterPage(page) {
      this.loadingMsg = 'Login.checking_encrypt';
      if (!page) {
        this.errorDia = true;
        this.errorMsg = 'Member.page_expired_1';
        this.pageLoading = false;
      }
      else {
        localStorage.setItem('aesCode', page);
        // 取得加密字串
        this.getEncryptData({ code: page }).then((res) => {
          if (res.data.pageStr) {
            this.loadingMsg = 'Login.checking_page';
            // ----
            localStorage.setItem('page', res.data.pageStr);
            // ----
            this.getPageData({ pageStr: this.fixedString(res.data.pageStr) })
              .then(() => {
                // STEP-2
                this.welcome();
              })
          }
          else {
            this.pageLoading = false;
            this.errorDia = true;
            this.errorMsg = 'Member.wrong_params';
          }
        })
      }
    },
    welcome() {
      const nowID   = localStorage.getItem(this.pageData.auth);
      const nowLang = this.pageData.lang ? this.pageData.lang : 'zh';
      // 設定環境語言
      this.$i18n.locale = nowLang;
      localStorage.setItem('lang', nowLang);
      // 如果之前登入過
      if (nowID) {
        // this.pageLoading = false;
        this.gotoMainPage();
      }
      else {
        this.config.autoRecom    = this.pageData.rec          ? this.pageData.rec  : '';
        this.config.isLIFF       = this.pageData.isLIFF       ? true               : false;
        this.config.noVer        = this.pageData.noVer        ? true               : false;
        this.config.isEmail      = this.pageData.Email        ? true               : false;
        this.config.double       = this.pageData.double       ? true               : false;
        this.config.requireEmail = this.pageData.requireEmail ? true               : false;
        // STEP-3
        this.fetchingData();
      }
      this.getBasicId({ ChannelID: this.pageData.auth }).then((_res) => {
        if (_res.data.Report) {
          this.basicId = _res.data.Report;
        }
      })
    },
    fetchingData() {
      this.loadingMsg = 'Login.get_user_data';
      let promise = [];
      promise.push(this.checkAccount({ Service: this.platform, Auth: this.pageData.auth }));
      promise.push(this.checkBindAcc({ service: this.platform, auth: this.pageData.auth }));
      // 確定平台
      if (this.platform === 'FB') {
        promise.push(this.checkUserFB({ PageID: this.pageData.auth, PSID: this.user.token }));
      }
      else {
        promise.push(this.checkUserLINE({ ChannelID: this.pageData.auth, UserID: this.user.token }));
      }
      promise.push(this.getNotReceivedUser({ service: this.platform, auth: this.pageData.auth, token: this.user.token }));
      promise.push(this.getAESData({ auth: this.pageData.auth, content: this.fixedString(this.content) }))
      // 一次要回所有資料
      Promise.all(promise).then((_result) => {
        // 如果已經是會員
        if (this.userData) {
          this.gotoMainPage();
        }
        else {
          this.pageLoading = false;
          if (this.account) {
            this.config.notReceivedLink = this.account.notReceivedLink ? this.account.notReceivedLink : '';
            this.config.privacyUrl = this.account.privateUrl ? this.account.privateUrl : 'https://www.eilis-ai.com/member-rule';
            this.config.isLoginRecom = this.account.isLoginRecom ? this.account.isLoginRecom : false;
            if (this.account.isLoginRecom) {
              this.config.loginRecom = this.account.loginRecom;
            }
            if (_result[1].isBind) {
              this.fastClearance.isBind = true;
              this.fastClearance.bindingData = _result[1].detail;
            }
            if (_result[3].data.Token) {
              this.user.phone = _result[3].data.Token.phone;
              this.user.name  = _result[3].data.Token.name  ? _result[3].data.Token.name  : '';
              this.user.email = _result[3].data.Token.email ? _result[3].data.Token.email : '';
              if (_result[3].data.Token.birth) {
                this.user.birth  = _result[3].data.Token.birth;
                this.birth.year  = _result[3].data.Token.birth.substr(0, 4);
                this.birth.month = _result[3].data.Token.birth.substr(4, 2);
                this.birth.date  = _result[3].data.Token.birth.substr(6, 2);
              }
            }
            // 檢查有無 content
            if (_result[4].data.result) {
              // STEP-3 看情況
              this.filterLogin(_result[4].data.result)
            }
            else {
              this.active = 0;
            }
          }
          else {
            this.errorDia = true;
            this.errorMsg = 'Login.not_open';
          }
        }
      })
    },
    filterLogin(userContent) {
      // 取得解密資料
      this.user.phone     = userContent.phone  ? userContent.phone  : '';
      this.user.email     = userContent.email  ? userContent.email  : '';
      this.user.name      = userContent.name   ? userContent.name   : '';
      this.user.birth     = userContent.birth  ? userContent.birth  : '';
      this.user.remark    = userContent.remark ? userContent.remark : '';
      // this.config.isEmail = userContent.email  ? true : false;
      if (userContent.birth && userContent.birth.substr(0, 4) !== '0000' && userContent.birth.substr(4, 2) !== '00' && userContent.birth.substr(6, 2) !== '00') {
        this.birth.year  = userContent.birth.substr(0, 4);
        this.birth.month = userContent.birth.substr(4, 2);
        this.birth.date  = userContent.birth.substr(6, 2);
      }
      if (userContent.status === '已驗證') {
        this.active = 2;
      }
      else {
        this.active = 0;
      }
    },
    callMemberAPI() {
      const content = {
        clientId: this.pageData.auth,
        phone: this.user.phone,
        birth: this.user.birth,
        name: this.user.name,
        email: this.user.email,
        // 這邊記得換成正式站網址
        envir: (location.hostname === 'emcpro.eilis-ai.com') ? 'pro' : 'dev',
        usId: (this.platform === 'LINE') ? this.user.token : '',
        psId: (this.platform === 'FB')   ? this.user.token : '',
      };
      this.sendMemberAPI(content);
    },
    // 完成驗證 看這裡
    checkFastLogin() {
      if (this.fastClearance.isBind) {
        this.pageLoading = true;
        this.loadingMsg  = 'Login.checking_code';
        this.checkBindUser({ service: this.fastClearance.bindingData.service, auth: this.fastClearance.bindingData.id, phone: this.user.phone })
          .then((res) => {
            if (res.isUser) {
              // 快速通關
              this.loadingMsg  = 'Login.awaiting_login';
              this.fastLogin({ service: this.platform, auth: this.pageData.auth, token: this.user.token, userData: res.userData })
                .then((resp) => {
                  if (resp.Message === '註冊成功') {
                    this.callMemberAPI();
                    this.gotoMainPage();
                  }
                  else {
                    this.pageLoading = false;
                    this.active = 2;
                  }
                })
              if (this.platform === 'LINE') {
                this.serUserToMemberMenu({ ChannelID: this.pageData.auth, UUID: this.user.token });
              }
            }
            else {
              this.pageLoading = false;
              this.active = 2;
            }
          })
      }
      else {
        this.active = 2;
      }
    },
    sendMember(data) {
      this.pageLoading = true;
      let recom = '';
      this.user = data.user;
      recom = data.recom;
      // 打串接客戶 API
      this.callMemberAPI();
      // 我們的註冊
      const postData = {
        PhoneNumber : this.user.phone,
        CountryCode : this.user.countryCode,
        Email       : this.user.email,
        Service     : this.platform,
        Auth        : this.pageData.auth,
        Token       : this.user.token,
        ID          : this.user.birth,
        Name        : this.user.name,
        remark      : this.user.remark
      };
      this.loadingMsg = 'Login.setting_login_data';
      this.createUser(postData).then((_res) => {
        this.loadingMsg = 'Login.awaiting_login';
        // 設定目前使用者
        let promise = [];
        // 設定標籤
        if (this.pageData.tag) {
          promise.push(this.addUserTag({ Service: this.platform, Auth: this.pageData.auth, UserPhone: this.user.phone, Tag: this.pageData.tag, BindServ: [this.platform] }));
        }
        if (this.pageData.gift) {
          promise.push(this.exchangeGiftCode({ service: this.platform, auth: this.pageData.auth, phone: this.user.phone, name: this.user.name, giftCode: this.pageData.gift }));
        }
        if (recom) {
          promise.push(this.sendLoginRecom({ service: this.platform, auth: this.pageData.auth, receivedPhone: this.user.phone, recomPhone: recom, loginRecom: this.config.loginRecom }));
        }
        if (this.platform === 'LINE') {
          promise.push(this.serUserToMemberMenu({ ChannelID: this.pageData.auth, UUID: this.user.token }));
        }
        Promise.all(promise).then((_result) => {
          this.gotoMainPage();
        })
        .catch((err) => {
          this.gotoMainPage();
        })
      })
      .catch((_err) => {
        this.pageLoading = false;
        this.errorDia = true;
        this.errorMsg = 'Login.register_failed';
      })
    }
  }
}

</script>


<style>
.form {
  margin: 0 auto;
  padding: 10px;
  width: 100%;
  max-width: 600px;
}
.privacy {
  color: #f24;
  text-decoration: underline;
}
.hintBox {
  border: 2px solid #222;
  display: inline-block;
  padding: 8px;
  width: 120px;
  text-align: center;
  border-radius: 10px;
  background-color: #4c7ecf;
  color: #fff;
  font-weight: 600;
}
.trian {
  border-color: transparent #555 transparent transparent;
  border-style: solid solid solid solid;
  /* 設定邊框（上、下；左、右）大小相同的數值，可拼湊出任意形狀的三角形 */
  border-width: 8px 15px; 
  /* 設定 width、height 可更好理解原理 */
  height: 0px; 
  width: 0px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 60px;
}
.box {
  position: absolute;
  width: 200px;
  text-align: left;
  padding: 10px;
  background-color: #555;
  border-radius: 5px;
  color: #fff;
  font-weight: 500;
  top: 50%;
  transform: translateY(-50%);
  left: 90px;
}
</style>